import axios from "axios";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
    headers: { "Content-Type": "application/json" },
});

// Ensure token is included in every request
API.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        console.warn("No token found in localStorage!");
    }
    
    console.log(`[API] Request: ${config.method.toUpperCase()} ${config.url}`, config);
    return config;
});

// Auth API
export const login = (userData) => API.post("/auth/login", userData);
export const register = (userData) => API.post("/auth/register", userData);

// Carbon Credit API
export const getCarbonCredits = () => API.get("/carbon-credits");
export const addCarbonCredit = (data) => API.post("/carbon-credits", data);

// Performance Metrics API (Mock Data)
export const getPerformanceMetrics = async () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                totalCOAvoided: 1234567,
                clinkerReduction: 856432,
                carbonCreditsGenerated: 45678,
                waterSaved: { current: 234567, target: 250000 },
                energyEfficiency: { current: 89, target: 90 },
                wasteReduction: { current: 67, target: 70 }
            });
        }, 500);
    });
};

// Legal Documents API
export const getLegalDocuments = () => API.get("/legal-documents");
export const uploadLegalDocument = (formData) => API.post("/legal-documents/upload", formData);

export const getProfile = () => API.get("/profile"); // ✅ Fetch user profile
export const updateProfile = (data) => API.put("/profile", data); // ✅ Update user profile

export default API;
